module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"uk":{"title":"Щоб переглянути це відео, авторизуйтесь у системі","login":"Автозуватись","text1":"Ще не маєте профіля? Ви можете","text2":"створити його","text3":"за кілька хвилин."},"en":{"title":"Please sign in to view this video","login":"Sing in","text1":"Don\u0027t have a profile yet? You can","text2":"create it","text3":"in minutes."}}')
  delete Component.options._Ctor
}
